/**
 * Helpers for opening a drafted pitch email in the user's preferred mail client.
 * Supports Gmail (web), Outlook (web), and native mailto: fallback.
 */

function toSubjectBody(email) {
  if (!email) return { subject: "", body: "" };
  if (typeof email === "string") {
    // Parse "Subject: X\n\nBody..." format
    const match = email.match(/^\s*subject:\s*([^\n]+)\n+([\s\S]*)$/i);
    if (match) return { subject: match[1].trim(), body: match[2].trim() };
    return { subject: "", body: email };
  }
  return {
    subject: (email.subject || "").trim(),
    body: (email.body || "").trim(),
  };
}

export function openInGmail(email, toAddress = "") {
  const { subject, body } = toSubjectBody(email);
  const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(toAddress)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function openInOutlook(email, toAddress = "") {
  const { subject, body } = toSubjectBody(email);
  const url = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(toAddress)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function openInMailto(email, toAddress = "") {
  const { subject, body } = toSubjectBody(email);
  const url = `mailto:${encodeURIComponent(toAddress)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = url;
}
